import React, { useRef, useEffect } from 'react'
import { Auth } from 'aws-amplify'
import { Text } from 'components/forms'
import Button from 'components/Button'
import Divider from 'components/Divider'
import style from './auth.module.scss'
import { validatePassword } from './utils'
import AuthContainer from './AuthContainer'
import { withTranslation } from 'react-i18next'

const RequireNewPassword = (props) => {
	const formApi = useRef(null)
	const { t, authProps } = props

	useEffect(() => {
		if(authProps.error && formApi.current) {
			switch(authProps.error) {
				case 'User is disabled':
					formApi.current.setError('username', t('auth_screen.error.user_disabled'))
					break
				case 'Network error':
					formApi.current.setError('username', t('auth_screen.error.network'))
					formApi.current.setError('code', t('auth_screen.error.network'))
					break
				case 'Attempt limit exceeded, please try after some time.':
					formApi.current.setError('username', t('auth_screen.error.try_limit'))
					formApi.current.setError('code', t('auth_screen.error.try_limit'))
					break
				case 'Invalid verification code provided, please try again.':
					formApi.current.setError('code', t('auth_screen.error.invalid_code'))
					break
				default:
					formApi.current.setError('username', t('auth_screen.error.unknown'))
					formApi.current.setError('code', t('auth_screen.error.unknown'))
					break
			}
		}
	}, [authProps.error])

	const getApi = api => {
		formApi.current = api
	}

	const sendCode = async ({ username }) => {
		await authProps.submitForm({
			username: username.toLowerCase()
		})
	}

	const resetPassword = async ({ code, newPassword }) => {
		await authProps.submitForm({
			confirmation_code: code,
			password: newPassword,
			confirm_password: newPassword

		})
	}

	return(
		<AuthContainer
			getApi={getApi}
			key={authProps.route}
			onSubmit={authProps.route === 'confirmResetPassword' ? resetPassword : sendCode}
			className={style.form}
			render={({ formState: { values, errors } }) => (
				<>
					{authProps.route === 'confirmResetPassword' ?
						<p>{t('auth_screen.message.new_pass_required')}</p> :
						<p>{t('auth_screen.message.reset_password')}</p>
					}
					<Divider height={20}/>
					{authProps.route === 'confirmResetPassword' ?
						<>
							<Text
								errors={errors}
								errorClass={style.formInputError}
								validate={v => (v ? null : t('auth_screen.error.code_required'))}
								validateOnChange
								type='text'
								field='code'
								placeholder={t('auth_screen.form.code')}
								usePlaceholder
							/>
							<Text
								errors={errors}
								errorClass={style.formInputError}
								validate={validatePassword(t)}
								autoComplete='new-password'
								validateOnChange
								type='password'
								field='newPassword'
								placeholder={t('auth_screen.form.new_password')}
								usePlaceholder
							/>
						</> :
						<Text
							errors={errors}
							errorClass={style.formInputError}
							validate={v => (v ? null : t('auth_screen.error.login_required'))}
							validateOnChange
							type='text'
							field='username'
							placeholder={t('auth_screen.form.login')}
							usePlaceholder
						/>
					}
					<Divider height={20}/>
					{authProps.route === 'confirmResetPassword' ?
						<Button
							status={Object.keys(errors).length ? 'inactive' : 'active'}
							text={t('auth_screen.button.save_password')}
							type='submit'
							{...authProps.isPending && { loading: true }}
						/> :
						<Button
							status={!values.username && errors.username ? 'inactive' : 'active'}
							text={t('auth_screen.button.reset_password')}
							type='submit'
							{...authProps.isPending && { loading: true }}
						/>
					}
					<div className={style.linkButton} onClick={authProps.toSignIn}>{t('auth_screen.button.go_back')}</div>
				</>
			)}
		/>
	)
}

export default withTranslation()(RequireNewPassword)
